/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Day_Finch_FileInputs */

const fr_true_day_finch_file = /** @type {(inputs: True_Day_Finch_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En continu`)
};

/**

* @param {True_Day_Finch_FileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const true_day_finch_file = /** @type {((inputs?: True_Day_Finch_FileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Day_Finch_FileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_true_day_finch_file(inputs)
});